import type { MarlinStoreDb } from "../infra/db";
import { assertValidSiteId } from "./validate";

export const getFavouriteSites = async (
  db: MarlinStoreDb,
  cognitoSub: string,
): Promise<number[]> =>
  (await db.favouriteSites.get(cognitoSub))?.siteIds ?? [];

export const toggleFavouriteSite = async (
  db: MarlinStoreDb,
  cognitoSub: string,
  siteId: number,
): Promise<number[]> => {
  if (!cognitoSub) return [];
  assertValidSiteId(siteId);
  return db.transaction("rw", db.favouriteSites, async () => {
    const current = await getFavouriteSites(db, cognitoSub);
    const siteIds = current.includes(siteId)
      ? current.filter((id) => id !== siteId)
      : [...current, siteId];
    await db.favouriteSites.put({ cognitoSub, siteIds });
    return siteIds;
  });
};
